import _ from "lodash";
import React from "react";
import { useLazyGetAssetsSummaryQuery } from "../../../services/valuations";

export const AssetsSummaryContext = React.createContext();

export const useAssetsSummaryData = () => React.useContext(AssetsSummaryContext);

export const AssetsSummaryProvider = ({ children, filter = null, isReady = false }) => {
    const [load, { data, error, isLoading, isFetching }] = useLazyGetAssetsSummaryQuery();

    const reload = () => {
        if (!isReady || !filter || _.isEmpty(filter)) {
            return;
        }
        load({ ...filter }).unwrap();
    };

    React.useEffect(reload, [ filter, isReady ]);

    return (
        <AssetsSummaryContext.Provider value={{ data, error, isFetching, isLoading }}>
            {children}
        </AssetsSummaryContext.Provider>
    )
}
